module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxdetail/inboxdetail_btn03_en-4984b488893f13ef777273e3deefa85d.jpg";